export default __webpack_public_path__ + "static/media/emelia.png.webp";